import { Floor } from "src/app/features/reservations/models/Reservation"

export enum AssignWaiterTypeEnum {
    Manually = 'Manually',
    Auto = 'Auto'
}
export enum AutoAssignTypeEnum {
    LowestReservations = 'LowestReservations',
    LastSeatedTime = 'LastSeatedTime',
    LowestPartySize = 'LowestPartySize'
}

export class WaiterAssignment {
    optionType!: AssignWaiterTypeEnum
    autoOptionType!: AutoAssignTypeEnum|null
    floors!: Floor[]
    restaurantId!: number
  }
